<template>
  <v-container fluid id="tf-pricing" class="tf-pricing-section py-8 py-md-16">
    <v-container>

      <v-row class="mb-10">
        <v-col cols="12" class="text-center">
          <span
            class="overline font-weight-bold"
            :style="{ color: '#00695C' }"
            data-aos="fade-down"
          >
            PLANES
          </span>
          <h2
            class="display-1 font-weight-bold primary--text mt-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Elegí el plan que se adapta a tu operación
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="(tier, i) in tiers"
          :key="i"
          cols="12"
          md="4"
          data-aos="fade-up"
          :data-aos-delay="String(200 + i * 100)"
        >
          <v-card
            class="tf-pricing-card pa-6 h-100 d-flex flex-column"
            :elevation="tier.featured ? 6 : 2"
            :class="{ 'tf-pricing-card--featured': tier.featured }"
          >
            <div class="d-flex align-center justify-space-between mb-4">
              <h3 class="text-h5 font-weight-bold primary--text">
                {{ tier.name }}
              </h3>
              <v-chip
                v-if="tier.featured"
                small
                color="success"
                text-color="white"
                class="font-weight-bold"
              >
                Más Popular
              </v-chip>
            </div>

            <div class="mb-6">
              <span
                class="text-h3 font-weight-black"
                :style="{ color: '#00695C' }"
              >
                {{ tier.basePrice }}
              </span>
              <span
                v-if="tier.basePeriod"
                class="body-1 greylight--text"
              >
                /{{ tier.basePeriod }}
              </span>
              <div
                v-if="tier.variablePrice"
                class="mt-2"
              >
                <span
                  class="text-h6 font-weight-bold"
                  :style="{ color: '#00695C' }"
                >
                  + {{ tier.variablePrice }}
                </span>
                <span class="body-2 greylight--text">
                  {{ tier.variableUnit }}
                </span>
              </div>
            </div>

            <v-list dense class="transparent pa-0 mb-4 flex-grow-1">
              <v-list-item
                v-for="(feature, j) in tier.features"
                :key="j"
                class="px-0"
                dense
              >
                <v-list-item-icon class="mr-2 my-auto">
                  <v-icon small :style="{ color: '#00695C' }">
                    mdi-check-circle
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2 greydark--text"
                    style="white-space: normal;"
                  >
                    {{ feature }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-btn
              v-if="tier.featured"
              :x-large="$vuetify.breakpoint.mdAndUp"
              :large="$vuetify.breakpoint.smAndDown"
              depressed
              block
              class="white--text mt-auto"
              :style="{ backgroundColor: '#00695C' }"
              href="#tf-contact"
              rounded
            >
              {{ tier.cta }}
            </v-btn>
            <v-btn
              v-else
              :x-large="$vuetify.breakpoint.mdAndUp"
              :large="$vuetify.breakpoint.smAndDown"
              outlined
              block
              :style="{
                color: '#00695C',
                borderColor: '#00695C',
              }"
              href="#tf-contact"
              rounded
              class="mt-auto"
            >
              {{ tier.cta }}
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          cols="12"
          class="text-center"
          data-aos="fade-up"
          data-aos-delay="600"
        >
          <p class="body-1 greylight--text">
            <v-icon
              small
              :style="{ color: '#00695C' }"
              class="mr-1"
            >mdi-information-outline</v-icon>
            Todos los planes incluyen 14 días de prueba gratis.
            Pagás solo por lo que usás — crecés con tu operación.
          </p>
        </v-col>
      </v-row>

    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'TFPricing',
  data() {
    return {
      tiers: [
        {
          name: 'Starter',
          basePrice: 'USD $75',
          basePeriod: 'mes',
          variablePrice: 'USD $0.50',
          variableUnit: 'por expediente',
          featured: false,
          cta: 'Empezar Gratis',
          features: [
            'Usuarios ilimitados',
            'Generación de documentos (BL, Packing List)',
            'Control de gastos por operación',
            'Soporte por email',
          ],
        },
        {
          name: 'Profesional',
          basePrice: 'USD $125',
          basePeriod: 'mes',
          variablePrice: 'USD $0.25',
          variableUnit: 'por expediente',
          featured: true,
          cta: 'Elegir Profesional',
          features: [
            'Usuarios ilimitados',
            'Todos los documentos de comex',
            'Validación AI: USD $0.10 / documento',
            'Conciliación de gastos y reportes',
            'Soporte prioritario',
          ],
        },
        {
          name: 'Enterprise',
          basePrice: 'A medida',
          basePeriod: null,
          variablePrice: null,
          variableUnit: null,
          featured: false,
          cta: 'Hablar con Ventas',
          features: [
            'Usuarios ilimitados',
            'Tarifa por volumen negociada',
            'Validación AI incluida',
            'API e integraciones (ERP, WMS)',
            'Soporte dedicado 24/7',
            'Onboarding personalizado',
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tf-pricing-section {
  background-color: #F5F5F5;
}

.tf-pricing-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
}

.tf-pricing-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 105, 92, 0.15) !important;
}

.tf-pricing-card--featured {
  border: 2px solid #00695C;
}

.transparent {
  background: transparent !important;
}

</style>
